/**
 * Headers object from test-api-endpoint / axios (keys may be any casing).
 */
export type SheetBridgeWarningHeaders = Record<string, string | undefined>

/**
 * Parse X-SheetBridge-Warnings from test-api-endpoint / axios response headers (JSON array of strings).
 */
export function readTruncationWarningFromHeaders(headers: unknown): string {
  if (!headers || typeof headers !== 'object') {
    return ''
  }
  const h = headers as SheetBridgeWarningHeaders
  const raw = h['x-sheetbridge-warnings'] ?? h['X-SheetBridge-Warnings']
  if (raw == null || raw === '') {
    return ''
  }
  try {
    const parsed: unknown = JSON.parse(raw)

    return Array.isArray(parsed) ? parsed.join(' ') : ''
  } catch {
    return ''
  }
}
